import React from 'react';
import { Plus, Minus } from 'lucide-react';
import type { FAQItem as FAQItemType } from './support.data';

interface FAQItemProps {
  item: FAQItemType;
  isOpen: boolean;
  onToggle: (id: string) => void;
}

const FAQItem: React.FC<FAQItemProps> = ({ item, isOpen, onToggle }) => {
  const panelId = `faq-panel-${item.id}`;
  const buttonId = `faq-button-${item.id}`;

  return (
    <div className={`support-faq-item ${isOpen ? 'open' : ''}`}>
      <h3 className="support-faq-heading">
        <button
          type="button"
          id={buttonId}
          className="support-faq-button"
          aria-expanded={isOpen}
          aria-controls={panelId}
          onClick={() => onToggle(item.id)}
        >
          <span className="support-faq-question">{item.question}</span>
          <span className="support-faq-icon" aria-hidden="true">
            {isOpen ? <Minus size={18} strokeWidth={2.2} /> : <Plus size={18} strokeWidth={2.2} />}
          </span>
        </button>
      </h3>
      <div
        id={panelId}
        role="region"
        aria-labelledby={buttonId}
        className="support-faq-panel"
        hidden={!isOpen}
      >
        <p className="support-faq-answer">{item.answer}</p>
      </div>
    </div>
  );
};

export default FAQItem;
